import React from 'react';
import ProductDetails from '../components/product/ProductDetails';

const Product = () => {
  return (
    <div className="product-page">
      <ProductDetails />
    </div>
  );
};

export default Product;